import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const MenuIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4 8H20" stroke={fillColor || '#111112'} strokeWidth="2" strokeLinecap="round" />
      <path d="M4 12H20" stroke={fillColor || '#111112'} strokeWidth="2" strokeLinecap="round" />
      <path d="M4 16H20" stroke={fillColor || '#111112'} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export { MenuIcon };
